import React from 'react';
import PropTypes from 'prop-types';
import CsvDownloader from 'react-csv-downloader';

import PdButton from 'components/pd-button';

/**
 * CSV Downloader Component with customizable button
 *
 * @param {React.RefObject} csvDownloader - Ref to trigger download programmatically
 * @param {Array<Object>} datas - Data to download as CSV
 * @param {string} filename - Name for the downloaded CSV file
 * @param {Function} onDownloadCsv - Callback function to fetch data before download
 * @param {string} buttonLabel - Text label for the download button
 * @param {boolean} noButton - If true, renders plain text instead of button
 * @param {string} separator - CSV separator character (default: ",")
 * @param {Object} rest - Additional props to pass to CsvDownloader
 */
export default function PdCsvDownloader({
  csvDownloader = undefined,
  datas = [],
  filename,
  buttonLabel = 'Download as CSV',
  noButton = false,
  separator = ',',
  wrapColumnChar = '',
  ...rest
}) {

  return (
    <CsvDownloader
        datas={datas}
        filename={filename}
        ref={csvDownloader}
        separator={separator}
        wrapColumnChar={wrapColumnChar}
        {...rest}>
        <div className={noButton ? 'no-button' : 'pd-csv-uploader'}>
         {noButton ? (
        <div >{buttonLabel}</div>
      ) : (
        <PdButton
          className="height-32"
          full
          type="primary"
          outline>
          {buttonLabel}
        </PdButton>
      )}
      </div>
      </CsvDownloader>
  );
}

PdCsvDownloader.propTypes = {
  csvDownloader: PropTypes.object,
  datas: PropTypes.array,
  filename: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string,
  noButton: PropTypes.bool,
  separator: PropTypes.string,
  wrapColumnChar: PropTypes.string,
};
